import { createContext, useContext } from "react";
import { config } from "@shared/envVariables";

export const ConfigContext = createContext(config);

export function useConfig() {
  return useContext(ConfigContext);
}
